import { useEffect, useRef, useState } from 'react';

import type { ImageModalV2OperationToastState } from './imageModalV2OperationToastTypes';

export const IMAGE_MODAL_V2_OPERATION_MINIMUM_PRESENTATION_MS = 240;

export const useImageModalV2OperationToastPresentation = (
    desiredToast: ImageModalV2OperationToastState | null,
): ImageModalV2OperationToastState | null => {
    const [presentedToast, setPresentedToast] = useState(desiredToast);
    const presentedAtRef = useRef(desiredToast ? Date.now() : 0);
    const clearTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (clearTimeoutRef.current) clearTimeout(clearTimeoutRef.current);
        clearTimeoutRef.current = null;

        if (desiredToast) {
            if (presentedToast?.message !== desiredToast.message) presentedAtRef.current = Date.now();
            if (presentedToast !== desiredToast) setPresentedToast(desiredToast);
            return undefined;
        }

        if (!presentedToast) return undefined;

        const elapsed = Date.now() - presentedAtRef.current;
        const remaining = Math.max(IMAGE_MODAL_V2_OPERATION_MINIMUM_PRESENTATION_MS - elapsed, 0);
        clearTimeoutRef.current = setTimeout(() => {
            clearTimeoutRef.current = null;
            setPresentedToast(null);
        }, remaining);

        return () => {
            if (clearTimeoutRef.current) clearTimeout(clearTimeoutRef.current);
            clearTimeoutRef.current = null;
        };
    }, [desiredToast, presentedToast]);

    return presentedToast;
};
